<template>
    <div class="section">
        <div class="bak">
            <h1 class="title is-size-2 is-size-3-mobile has-text-primary">Om oss</h1>
            <p class="is-size-5 is-size-6-mobile has-text-white">
                General Hotell er et lite familiedrevet konferansehotell i en grønn næringspark syd for Hønefoss. Hos oss er det 1 time til "alt"; Gardermoen, Oslo, Drammen, Kongsberg og Valdres. Hotellet ligger nære Storelva, som renner ut i Tyrifjorden, og det er 10 minutter til Nordmarka og Krogskogen. Her på Helgelandsmoen har det militære hatt tilhold siden 1869. I 2004 ble området helt privat og i 2009 åpnet General Hotell dørene. Vårt nyeste tilbygg kom i 2011.
            </p>
            <p class="is-size-5 is-size-6-mobile has-text-white avsnitt">
                Som mennesker er vi hjelpsomme, personlige og uformelle, samt presise i vårt arbeide.
            </p>
            <p class="is-size-5 is-size-6-mobile has-text-white avsnitt">
                Vårt kjøkken er internasjonalt, med franske røtter. Huset har også en ekte italiensk trattoria som a la carte tilbud.
            </p>
            <p class="is-size-5 is-size-6-mobile has-text-white avsnitt">
                Lokalene bærer preg av et nøkternt og moderne skandinavisk design. I 2011 bygget vi nye konferansesaler som er smakfullt innredet og meget godt rustet med moderne teknologi. Balansert ventilasjon finner du i alle oppholds- og møterom. Værelsene var nye i 2009 og er både praktiske og komfortable etter dagens krav.
            </p>
            <p class="is-size-5 is-size-6-mobile has-text-white avsnitt">
                Ringeriksbadet, Actic Gym og Galleri Klevjer er gode naboer som mange av våre gjester besøker. Vi hjelper også våre kunder med å planlegge andre tilpassede aktiviteter.
            </p>
            <p class="is-size-5 is-size-6-mobile has-text-white avsnitt">
                Som relativt nyetablerte er vi selvsagt også svært konkurransedyktige på pris!
            </p>
        </div>
    </div>
</template>

<script>
export default {
    title: 'Om oss',
    metaInfo: {
        meta: [
        { name: 'description', content: 'General Hotell er et lite familiedrevet konferansehotell rett utenfor Hønefoss. Vi tilbyr overnatting i 21 rom, konferansepakker, kurslokaler, møterom, restaurant og selskapslokaler. Husets restaurant, Pizzeria del Generale, er et populær spisested blant befolkningen i Hønefoss og Hole.'},
        { name: 'keywords', content: 'hotell, hønefoss, B&B, kurshotell, konferansehotell, kurs og konferanse, kurs- og konferanse, overnatting, møtepakker, restaurant, pizzeria, selskapslokaler, events' }
        ]
    },            
}
</script>

<style scoped>
.bak {
    background-color: #000;
    opacity: 0.7;
    display: block;
    padding: 10px 10px 30px 10px;
    margin-bottom:200px;
}

.avsnitt {
    margin-top:1.5vw;
}
</style>